export const CONTACT_GET_CONTACT_PRIVILEGES = 'CONTACT_GET_CONTACT_PRIVILEGES';
export const CONTACT_GET_CONTACT_RESOURCES = 'CONTACT_GET_CONTACT_RESOURCES';
export const CONTACT_GET_CONTACT_TYPES = 'CONTACT_GET_CONTACT_TYPES';
export const CONTACT_GET_CONTACT_SCALABILITY_LEVELS = 'CONTACT_GET_CONTACT_SCALABILITY_LEVELS';
export const CONTACT_GET_SCALABILITY_LEVELS = 'CONTACT_GET_SCALABILITY_LEVELS';
export const CONTACT_GET_CONTACT_TO_BE_UPDATED = 'CONTACT_GET_CONTACT_TO_BE_UPDATED';
export const CONTACT_GET_FORM_VIEW = 'CONTACT_GET_FORM_VIEW';
export const CONTACT_GET_LAST_ROUTE = 'CONTACT_GET_LAST_ROUTE';

export enum ContactsGetters {
    GET_CURRENT_SELECTED_CONTACT_RESOURCES = 'GET_CURRENT_SELECTED_CONTACT_RESOURCES',
    GET_DIRECTORY = 'GET_DIRECTORY',
    GET_CURRENT_SELECTION = 'GET_CURRENT_SELECTION',
    GET_AVAILABLE_RESOURCES = 'GET_AVAILABLE_RESOURCES',
    GET_CONTACT_TICKETS = 'GET_CONTACT_TICKETS',
}
